import { render, staticRenderFns } from "./ExchangeRequestManager.vue?vue&type=template&id=a2bc60f6"
import script from "./ExchangeRequestManager.vue?vue&type=script&lang=js"
export * from "./ExchangeRequestManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports